/* eslint-disable jquery/no-ajax */
/* eslint-disable no-undef */
import { normalize } from 'normalizr';

import { axiosInstance as axios } from 'hb-react/shared/utils/axios';

import * as actionTypes from '../constants/ActionTypes';
import Schemas from '../reducers/schema';

/* ------------------------------------- */
// Load all followings
/* ------------------------------------- */
export const fetchingFollowings = () => ({
  type: actionTypes.FETCHING_FOLLOWINGS,
});

export const fetchedFollowings = (followings, total) => ({
  type: actionTypes.FETCHED_FOLLOWINGS,
  payload: { followings, total },
});

export const fetchFollowingsIfNeeded = (topicId) => (dispatch, getState) => {
  if (shouldFetchFollowings(getState())) {
    return dispatch(fetchFollowings(topicId));
  }

  return dispatch(
    fetchedFollowings(
      normalize(
        getState().followings.get('followings').toJS(),
        Schemas.FOLLOWINGS,
      ),
    ),
  );
};

export const fetchFollowings = (topicId) => (dispatch) => {
  dispatch(fetchingFollowings());

  return axios
    .get(Routes.topics_topic_followings_path(topicId, { format: 'json' }))
    .then((response) => {
      dispatch(
        fetchedFollowings(
          normalize(response.data.followings, Schemas.FOLLOWINGS),
          response.data.total,
        ),
      );
    });
};

const shouldFetchFollowings = (state) =>
  !state.followings.get('followings_fetched_at');

/* ------------------------------------- */
// Follow topics
/* ------------------------------------- */
export const followedTopic = (following) => ({
  type: actionTypes.FOLLOWED_TOPIC,
  payload: normalize(following, Schemas.FOLLOWING),
});

export const followTopic = (topicId) => (dispatch) =>
  $.ajax({
    type: 'POST',
    url: Routes.topics_topic_followings_path(topicId),
    dataType: 'json',
  }).done((json) => dispatch(followedTopic(json.following)));

/* ------------------------------------- */
// Unfollow topics
/* ------------------------------------- */
export const unfollowedTopic = (following) => ({
  type: actionTypes.UNFOLLOWED_TOPIC,
  payload: following,
});

export const unfollowTopic = (topicId, following) => (dispatch) =>
  $.ajax({
    type: 'PUT',
    url: Routes.unfollow_topics_topic_following_path(topicId, following.id),
    dataType: 'json',
  }).done((json) => {
    dispatch(unfollowedTopic(normalize(json.following, Schemas.FOLLOWING)));

    setTimeout(() => (window.location.href = Routes.topics_path()), 100);
  });

/* ------------------------------------- */
// Update following settings
/* ------------------------------------- */
export const updatedSettings = (following) => ({
  type: actionTypes.UPDATE_SETTINGS,
  payload: following,
});

export const updateSettings = (topicId, following, params) => (dispatch) =>
  $.ajax({
    type: 'PUT',
    url: Routes.update_settings_topics_topic_following_path(
      topicId,
      following.id,
    ),
    data: params,
    dataType: 'json',
  }).done((json) =>
    dispatch(updatedSettings(normalize(json.following, Schemas.FOLLOWING))),
  );
